module.exports = __webpack_public_path__ + "img/default_hero_org_2.59839311.png";